import { useEffect } from "react";

/**
 * 2026-10-27 — the same words the app uses for an Expert (Dog's 10-24 display ruling):
 * the title is the base name ("Home Plumbing Repair"), the line beneath carries the
 * trained date, the Edition in ordinal form (never "Gen7") and the Engine.
 * The catalog keeps "Gen N" in its data; only the screen changes.
 */

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function ordinal(n) {
  const v = n % 100;
  if (v >= 11 && v <= 13) return `${n}th`;
  return `${n}${({ 1: "st", 2: "nd", 3: "rd" })[n % 10] || "th"}`;
}

/** "Investing & Trading Gen14 (7B)" → { title: "Investing & Trading", gen: 14, engine: "7B" } */
export function parseExpertName(name = "") {
  const m = /^(.*?)\s+Gen\s?(\d+)\s*(?:\((\d+B)\))?\s*$/i.exec(String(name).trim());
  if (!m) return { title: String(name).trim(), gen: null, engine: null };
  return { title: m[1].trim(), gen: parseInt(m[2], 10), engine: m[3] || null };
}

/** quarry-20261017-5022dab9 → "Oct 17, 2026" (the run's own date). */
export function trainedDate(id = "") {
  const m = /(\d{4})(\d{2})(\d{2})/.exec(String(id));
  if (!m) return null;
  const mo = parseInt(m[2], 10) - 1;
  if (mo < 0 || mo > 11) return null;
  return `${MONTHS[mo]} ${parseInt(m[3], 10)}, ${m[1]}`;
}

export function engineLabel(engineId = "", fallback = "") {
  const m = /engine-(\d+b)/i.exec(String(engineId));
  return m ? `${m[1].toUpperCase()} Engine` : (fallback || "");
}

/** Everything a card needs for one catalog Expert. */
export function describeExpert(e = {}) {
  const p = parseExpertName(e.name);
  const date = trainedDate(e.id);
  const engine = e.engine_label || engineLabel(e.engine_id) || (p.engine ? `${p.engine} Engine` : "");
  const parts = [];
  if (date) parts.push(`Trained ${date}`);
  if (p.gen) parts.push(`${ordinal(p.gen)} Edition`);
  if (engine) parts.push(engine);
  return { title: p.title || e.name, line: parts.join(" · "), engine, edition: p.gen ? `${ordinal(p.gen)} Edition` : "", date };
}

export function sizeText(e = {}) {
  if (e.size_mb) return `${e.size_mb} MB`;
  if (e.size_gb) return `${e.size_gb} GB`;
  return "";
}

/** 302 → "About 5 h", 45 → "About 45 min". */
export function readyText(min) {
  if (!min || min <= 0) return "";
  if (min < 60) return `About ${min} min`;
  const h = Math.floor(min / 60), m = min % 60;
  return m >= 10 ? `About ${h} h ${m} min` : `About ${h} h`;
}

export function bytesText(n) {
  if (!n) return "";
  if (n >= 1e9) return `${(n / 1e9).toFixed(1)} GB`;
  return `${Math.round(n / 1e6)} MB`;
}

/** The tab title, per page. */
export function useTitle(t) {
  useEffect(() => {
    document.title = t ? `${t} — Experts` : "Experts — Private AI that lives on your phone";
  }, [t]);
}
